/* eslint-disable security/detect-object-injection */

export const distributeDivision = (total, divisor, terms)  => {
    const result = [];
    const divisionResult = total / divisor;
    for (let i = 0; i < terms - 1; i++) {
        result.push(divisionResult.toFixed(2));
    }
    // For the last term, adjust to ensure the sum matches the total
    const lastTerm = (total - result?.reduce((acc, val) => acc + parseFloat(val), 0)).toFixed(2);
    result.push(lastTerm);
    return result;
}

export const distributeAmounts = (amounts, terms, key, givenIndex) => {
    let totalCount = amounts?.map((obj, index) => {
        return distributeDivision(obj[key], terms, terms)[givenIndex]
    })
    const totalValue = totalCount?.reduce((acc, val) => acc + parseFloat(val), 0);
    return totalValue;
}
